// ✅ Dashboard.jsx (use it like a professional dashboard section)
// Just import + drop the component where you want the table to appear.

import { React, useEffect, useState } from 'react';
import './dashboard.css';
import ApiService from '../../../services/apiService';

import RevenueCard from './ItemCard/revenueCard';
import StockInformation from './Stock/stockInfo';
import OrderSummery from './orderSum/orderSum';

// ✅ add this import
import ExpiryItemsCard from './expiryItemCard';

const Dashboard = () => {
  const [selectedFilter, setSelectedFilter] = useState('4');
  const [data, setData] = useState([]);

  const ThirdFilter = [
    { value: '0', label: 'Day' },
    { value: '1', label: 'Week' },
    { value: '2', label: 'Month' },
    { value: '3', label: 'Year' },
    { value: '4', label: 'All Time' },
  ];

  useEffect(() => {
    getSumData(selectedFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter]);

  const handleFilterChange = async (selectedFilterObj) => {
    setSelectedFilter(selectedFilterObj?.value);
  };

  const getSumData = async () => {
    try {
      const apiService = new ApiService();
      let paramaters = `?GetBy=${selectedFilter}`;
      let res = await apiService.getApiParamater('DASH_THIRD_COUNT', paramaters);
      setData(res?.data?.result?.reverse?.() || []);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <div className="p-lg-5 m-0">
      <div className="pb-4 pt-2 end mbl-center">
        <nav className="nav nav-pills weekfilter ">
          {ThirdFilter?.map((filter) => (
            <button key={filter?.value} className={`nav-link ${selectedFilter === filter.value ? 'activecls' : ''}`} onClick={() => handleFilterChange(filter)}>
              {filter?.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="py-lg-5">
        <div className="trdptybox  p-lg-5 ">
          <RevenueCard val={selectedFilter} />
        </div>
      </div>

      <div className="row justify-content-between">
        <div className="col-lg-6">
          <StockInformation />
        </div>
        <div className="col-lg-6">
          <OrderSummery val={selectedFilter} />
        </div>
      </div>

      {/* ✅ Professional dashboard table section */}
      <ExpiryItemsCard pageSize={8} defaultDays={10} />
    </div>
  );
};

export default Dashboard;
